export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage: 'radial-gradient(circle at 20% 50%, oklch(0.70 0.17 63 / 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 20%, oklch(0.58 0.17 20 / 0.2) 0%, transparent 50%)',
          }}
        />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block text-xs font-medium tracking-widest uppercase text-primary-600 bg-primary-50/80 px-3 py-1.5 rounded-full mb-6">
              官方入口实时收录
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
              51cg — 最新网址导航与平台综合指南
            </h1>

            <p className="mt-4 text-lg md:text-xl text-primary-600 font-heading">
              追踪可用域名，安全直达51cg官方平台
            </p>

            <div className="mt-6 space-y-3">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
                51cg作为一个综合性内容平台，汇聚了丰富的资讯与社区互动资源。本站作为网址导航站点，持续追踪并收录51cg官方最新可用域名与入口信息，帮助用户快速了解51cg.fun是什么、如何访问51cg官网，并提供全面的平台功能介绍与使用指南。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
                当前平台内容覆盖多个领域，更新频率稳定，社区活跃度持续增长。本站实时同步官方域名变更动态，确保您始终通过正确入口访问。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-8">
              <div className="flex items-center gap-1.5 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                每日更新域名
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                多重入口验证
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                安全访问保障
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline"
              >
                查看最新网址
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 rounded-lg text-sm font-medium hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline border border-background-200/70"
              >
                了解平台详情
                <i className="ri-information-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20abstract%20digital%20information%20network%20visualization%20with%20interconnected%20nodes%20and%20flowing%20data%20streams%2C%20warm%20golden%20and%20coral%20accents%20on%20light%20cream%20background%2C%20minimalist%20tech%20aesthetic%2C%20geometric%20patterns%20representing%20content%20navigation%20and%20information%20aggregation%2C%20soft%20gradient%20overlay%2C%20clean%20professional%20design%2C%20no%20text%20or%20labels&width=1200&height=900&seq=hero-visual-51cg&orientation=landscape"
                alt="51cg网址导航 - 数字信息网络可视化"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-background-50/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}